import { LookupType } from '../../types/models/lookup';
/**
 * String and Numeric operators:
 * equal
 * notEqual
 *
 * Numeric operators:
 * lessThan
 * lessThanInclusive
 * greaterThan
 * greaterThanInclusive
 *
 * Array operators:
 * in
 * notIn
 * contains
 * doesNotContain
 */

export enum Operator {
  EQUAL = 'equal to',
  NOT_EQUAL = 'not equal to',
  GREATER_THAN = 'greater than',
  LESS_THAN = 'less than',
  CONTAINS = 'containing',
  NOT_CONTAINS = 'not containing',
  ONE_OF = 'one of',
  NOT_ONE_OF = 'not one of',
}

export interface ICondition {
  fieldName: string;
  operator: Operator;
  value: string;
  label?: string;
  lookup?: LookupType;
}

/**
 * Verify that the given @param object is of type ICondition
 *
 * @param {any} object The object to test
 * @return {boolean} True if the @param object is of type ICondition
 */
export const isInstanceOfCondition = (object: any): boolean => {
  return 'fieldName' in object && 'operator' in object && ('value' in object || 'label' in object);
};
